import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Menu, X } from "lucide-react";
import { CONTACT } from "@/data/site";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Free Inspection", href: "#inspection" },
  { label: "Book a Visit", href: "#book" },
  { label: "Get a Quote", href: "#quote" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="logo-link">
          <img src="/logo.png" alt="247 Aftermath Restoration Mgmt" className="h-16 w-auto" />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm text-[#A3A3A3] hover:text-gold transition-colors duration-300 tracking-wide"
              data-testid={`nav-${n.href.replace('#','')}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={CONTACT.phoneHref}
            className="hidden sm:inline-flex items-center gap-2 bg-gold text-black font-semibold px-5 py-2.5 hover:bg-gold-light transition-colors duration-300 text-sm"
            data-testid="header-call-btn"
          >
            <Phone className="h-4 w-4" /> {CONTACT.phone}
          </a>
          <button
            className="md:hidden text-[#F5F5F0] p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-black/90 backdrop-blur-xl border-b border-white/10"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {NAV.map((n) => (
                <a key={n.href} href={n.href} onClick={() => setOpen(false)} className="text-[#F5F5F0] text-lg font-display" data-testid={`mobile-nav-${n.href.replace('#','')}`}>
                  {n.label}
                </a>
              ))}
              <a href={CONTACT.phoneHref} className="inline-flex items-center gap-2 bg-gold text-black font-semibold px-5 py-3 w-fit" data-testid="mobile-call-btn">
                <Phone className="h-4 w-4" /> {CONTACT.phone}
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
